import { render } from "./BannedDomainsTable.vue?vue&type=template&id=2d3fa283&scoped=true"
import script from "./BannedDomainsTable.vue?vue&type=script&lang=js"
export * from "./BannedDomainsTable.vue?vue&type=script&lang=js"

import "./BannedDomainsTable.vue?vue&type=style&index=0&id=2d3fa283&scoped=true&lang=css"
import "./BannedDomainsTable.vue?vue&type=style&index=1&id=2d3fa283&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3fa283"]])

export default __exports__